import { Icon } from '@unite-us/ui';
import PropTypes from 'prop-types';
import React from 'react';
import ToolTip from '../../../common/ToolTip/ToolTip';
import { ProfileViewDetail } from '../../../common/ProfileView/ProfileViewDetail';
var Success = function Success(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconCheckCircle",
    className: "fill-current text-green mr-1"
  }), /*#__PURE__*/React.createElement("p", null, message));
};
var Failure = function Failure(_ref2) {
  var message = _ref2.message;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement(ToolTip, {
    tooltipContent: "You cannot continue with the Pilot enrollment process until this field returns a green check mark."
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconTimesCircle",
    className: "fill-current text-red mr-1"
  })), /*#__PURE__*/React.createElement("p", null, message));
};
export var MatchView = function MatchView(_ref3) {
  var label = _ref3.label,
    match = _ref3.match,
    successMessage = _ref3.successMessage,
    failureMessage = _ref3.failureMessage,
    pending = _ref3.pending;
  var renderMessage = function renderMessage() {
    if (pending) return /*#__PURE__*/React.createElement("p", null, "Checking records...");
    if (match) return /*#__PURE__*/React.createElement(Success, {
      message: successMessage
    });
    return /*#__PURE__*/React.createElement(Failure, {
      message: failureMessage
    });
  };
  return /*#__PURE__*/React.createElement(ProfileViewDetail, {
    label: label
  }, renderMessage());
};
MatchView.propTypes = {
  label: PropTypes.string.isRequired,
  match: PropTypes.bool,
  successMessage: PropTypes.string.isRequired,
  failureMessage: PropTypes.string.isRequired,
  pending: PropTypes.bool.isRequired
};
MatchView.defaultProps = {
  match: null
};
//# sourceMappingURL=MatchView.js.map